import { makeAutoObservable, runInAction } from 'mobx';
import agent from '../api/agent';
import { Vehicle, VehicleCreate, VehicleEdit } from '../models/Vehicle';

export default class VehicleStore {
    vehicleRegistry = new Map<number, Vehicle>();
    loadingInitial = false;
    page = 1;
    hasNext = false;
    totalCount = 0;
    searchTerm = '';
    source = '';
    sort = 'fitment-fields asc';
    year = '';
    make = '';
    model = '';
    assigned = '';
    fieldValues: Record<string, string> = {};

    constructor() {
        makeAutoObservable(this);
    }

    get vehicles() {
        return Array.from(this.vehicleRegistry.values());
    }

    loadVehicles = async (
        page: number = 1,
        query: string = this.searchTerm,
        source: string = this.source,
        sort: string = this.sort,
        year: string = this.year,
        make: string = this.make,
        model: string = this.model,
        assigned: string = this.assigned,
        fieldValues: Record<string, string> = this.fieldValues
    ) => {
        this.loadingInitial = true;

        try {
            const result = await agent.Vehicles.list(
                page,
                query,
                source,
                sort,
                year,
                make,
                model,
                assigned,
                fieldValues
            );

            runInAction(() => {
                this.vehicleRegistry.clear();

                result.vehicles.forEach(v => {
                    this.vehicleRegistry.set(v.id, v);
                });

                this.page = page;
                this.searchTerm = query;
                this.source = source;
                this.sort = sort;
                this.year = year;
                this.make = make;
                this.model = model;
                this.assigned = assigned;
                this.fieldValues = { ...fieldValues };
                this.hasNext = result.hasNext;
                this.totalCount = result.totalCount;
                this.loadingInitial = false;
            });
        } catch (error) {
            console.log(error);

            runInAction(() => {
                this.loadingInitial = false;
            });
        }
    }

    create = async (vehicle: VehicleCreate) => {
        await agent.Vehicles.create(vehicle);
    }

    update = async (id: number, vehicle: VehicleEdit) => {
        await agent.Vehicles.update(id, vehicle);
    }

    delete = async (id: number) => {
        await agent.Vehicles.delete(id);
    }

    bulkDelete = async (payload: any) => {
        await agent.Vehicles.bulkDelete(payload);
    }

    filterOptions = async (year: string = '', make: string = '', source: string = this.source, fieldValues?: Record<string, string>) => {
        return await agent.Vehicles.filterOptions(year, make, source, fieldValues);
    }
}
